import React from 'react';

// import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const ImplementasiPelaksanaanGCG = () => {
    return (
        <section className="bg-white pt-10">
            <div className="container mx-auto pt-10">
                {/* Header Section */}
                <div className="mb-12">
                    <h2 className="text-3xl font-bold text-[#005da2] mb-6 text-center" data-aos="fade-down">Implementasi Pelaksanaan GCG</h2>
                    <p className="text-lg text-gray-700 leading-relaxed text-justify" data-aos="fade-down">
                        PT Len Telekomunikasi Indonesia berkomitmen untuk menerapkan prinsip-prinsip Corporate Governance Code (CGC) dalam setiap aspek bisnis dan operasional. Penerapan tersebut berlandaskan lima prinsip utama, yaitu keterbukaan, akuntabilitas, responsibilitas, independensi, dan kesetaraan. Perusahaan meyakini bahwa konsistensi dalam penerapan GCG akan memperkuat posisi perusahaan dalam menghadapi persaingan, meningkatkan efektivitas serta efisiensi pengelolaan sumber daya, memaksimalkan nilai perusahaan dalam jangka panjang, serta membangun kepercayaan para pemangku kepentingan.
                    </p>
                    <p className="text-lg text-gray-700 leading-relaxed text-justify py-5" data-aos="fade-down">
                        PT Len Telekomunikasi Indonesia berkomitmen untuk senantiasa menerapkan standar Tata Kelola Perusahaan yang Baik dan terus meningkatkan implementasi GCG secara berkelanjutan, tidak hanya sebatas memenuhi regulasi dan ketentuan yang berlaku. Dalam pelaksanaannya, perusahaan mengadopsi standar yang ditetapkan oleh Kementerian Badan Usaha Milik Negara (Kementerian BUMN).
                    </p>
                </div>
            </div>
        </section>
    );
};

export default ImplementasiPelaksanaanGCG;
